import React from 'react';
import {Image, PageHeader} from "antd";

const GetStarted = () => {
  return (
    <>
            <article>
                    <PageHeader
                        className="site-page-header"
                        title="Начало работы"
                    />
                    <h3>Установка и запуск</h3>
                    <p>Используйте пакетный менеджер <a href="https://www.npmjs.com/get-npm" rel="nofollow">npm</a> для
                            установки проекта.</p>
                    <div>
                            <pre>npm install</pre>
                    </div>
                    <p>Запуск приложения в режиме разработчика</p>
                    <div>
                            <pre>npm start</pre>
                    </div>
                    <h3>Сборка приложения в production mode</h3>
                    <div className="highlight highlight-source-shell">
                            <pre>npm run build</pre>
                    </div>
                    <h3>Стиль кода</h3>
                    <p>Форматирование prettier</p>
                    <div className="highlight highlight-source-shell">
                            <pre>npm run format</pre>
                    </div>
                    <p>Проверка кода eslint</p>
                    <div className="highlight highlight-source-shell">
                            <pre>npm run lint</pre>
                    </div>
                    <h3>Демо:</h3>
                    <a href='https://schedule-team46.netlify.com/'>
                            <Image
                                width={800}
                                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601226927/documentation/Screenshot_2020-09-27_at_20.15.12_svch2j.png"
                            />
                    </a>
                    <h3>Лицензии:</h3>
                    <p>Open source Copyright (c) 2020 RS React group 46</p>
            </article>
    </>
  );
};

export default GetStarted;